

import React, { memo, useContext } from 'react';
import cx from 'classnames';
import DataTableHeaderCell from './DataTableHeaderCell';
import DataTableHeaderRow from './DataTableHeaderRow';
import { DataTableContext } from '../../context/dataTableContext';



const DataTableHeader = () => {
  const { columns } = useContext(DataTableContext);

  return (
    <thead className={cx('data-table-header')}>
      <DataTableHeaderRow>
        {columns.map((column) =>
        <DataTableHeaderCell key={column.field} column={column} />
        )}
      </DataTableHeaderRow>
    </thead>);

};

export default memo(DataTableHeader);